import isNumber from './is-number';
var isPositive = function (num) {
  return isNumber(num) && num > 0;
};
export default isPositive;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.17@@antv/util/esm/is-positive.js
// module id = 70
// module chunks = 0